import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { PackageIdSchema, ServiceIdSchema } from '../unique-id.models.ts'

export const ProductIdSchema = z.union([PackageIdSchema, ServiceIdSchema])
export type ProductId = ZodInfer<typeof ProductIdSchema>
